// anything less than this and we possibly have text overlapping
const minAmountToDisplayDistanceWithoutComparison = 20;
const minAmountToDisplayDistancePlusComparison = 60;

const getDistanceLabel = ({ distance }) => ({
  distance,
  position: 'inside-bar'
});
const getDistanceLabelOutside = ({ distance }) => ({
  distance,
  position: 'outside-bar'
});
const getDistancePlusComparisonLabel = ({ comparisonDistance, distance }) => ({
  comparisonDistance,
  distance,
  position: 'inside-bar'
});
const getComparisonDistanceLabel = ({ comparisonDistance }) => ({
  distance: comparisonDistance,
  position: 'inside-bar'
});
const getComparisonDistancePlusDistanceLabel = ({
  comparisonDistance,
  distance
}) => ({
  comparisonDistance,
  distance,
  position: 'inside-bar'
});
const getComparisonDistancePlusDistanceLabelOutside = ({
  comparisonDistance,
  distance
}) => ({
  comparisonDistance,
  distance,
  position: 'outside-bar'
});

// <hasSpaceInDistanceBarForDistance><hasSpaceInDistanceBarForDistancePlusComparisonDistance><hasSpaceInComparisonDistanceBarForComparisonDistance><hasSpaceInComparisonDistanceBarForComparisonDistancePlusDistance><hasComparisonDistance>
const distanceLabelStrategies = {
  falsefalsefalsefalsefalse: getDistanceLabelOutside,
  truefalsefalsefalsefalse: getDistanceLabel,
  truefalsetruefalsetrue: getDistanceLabel,
  truefalsetruetruetrue: getDistanceLabel,
  truetruefalsefalsefalse: getDistanceLabel,
  truetruefalsefalsetrue: getDistancePlusComparisonLabel,
  truetruetruefalsetrue: getDistanceLabel,
  truetruetruetruetrue: getDistanceLabel
};

const comparisonDistanceLabelStrategies = {
  falsefalsefalsefalsetrue: getComparisonDistancePlusDistanceLabelOutside,
  falsefalsetruefalsetrue: getComparisonDistancePlusDistanceLabelOutside,
  falsefalsetruetruetrue: getComparisonDistancePlusDistanceLabel,
  truefalsefalsefalsetrue: getComparisonDistancePlusDistanceLabelOutside,
  truefalsetruefalsetrue: getComparisonDistanceLabel,
  truefalsetruetruetrue: getComparisonDistanceLabel,
  truetruetruefalsetrue: getComparisonDistanceLabel,
  truetruetruetruetrue: getComparisonDistanceLabel
};

export function getLabels({ comparisonDistance, distance, min }) {
  const hasSpaceInDistanceBarForDistance =
    distance - min >= minAmountToDisplayDistanceWithoutComparison;
  const hasSpaceInDistanceBarForDistancePlusComparisonDistance =
    distance - min >= minAmountToDisplayDistancePlusComparison;
  const hasSpaceInComparisonDistanceBarForComparisonDistance =
    comparisonDistance > 0
      ? comparisonDistance - distance >=
        minAmountToDisplayDistanceWithoutComparison
      : false;
  const hasSpaceInComparisonDistanceBarForComparisonDistancePlusDistance =
    comparisonDistance > 0
      ? comparisonDistance - distance >=
        minAmountToDisplayDistancePlusComparison
      : false;
  const hasComparisonDistance =
    comparisonDistance > 0 && comparisonDistance !== distance;

  return {
    comparisonDistanceLabel: comparisonDistanceLabelStrategies[
      `${hasSpaceInDistanceBarForDistance}${hasSpaceInDistanceBarForDistancePlusComparisonDistance}${hasSpaceInComparisonDistanceBarForComparisonDistance}${hasSpaceInComparisonDistanceBarForComparisonDistancePlusDistance}${hasComparisonDistance}`
    ]?.({ comparisonDistance, distance }),
    distanceLabel: distanceLabelStrategies[
      `${hasSpaceInDistanceBarForDistance}${hasSpaceInDistanceBarForDistancePlusComparisonDistance}${hasSpaceInComparisonDistanceBarForComparisonDistance}${hasSpaceInComparisonDistanceBarForComparisonDistancePlusDistance}${hasComparisonDistance}`
    ]?.({ comparisonDistance, distance })
  };
}
